<template>
<CRow>
  <CCol col="12" xl="12">
    <CCard>
      <CCardHeader>
        <CCol col="6" style="font-size: 25px;">عرض الدورة</CCol>
      </CCardHeader>
      <CCardBody>
        <div class="row">
            <div class="col-md-6 " col="6">
               <h5> بيانات الدورة </h5>
                <table class="table table-bordered main-table">
                  <tr>
                    <th> القسم الفرعي</th>
                    <td>{{ course.sub_category.name_ar }}</td>
                  </tr>
                  <tr>
                    <th>الإسم</th>
                    <td>{{ course.name }}</td>
                  </tr>
                  <tr>
                    <th> الإسم بالعربي</th>
                    <td>{{ course.name_ar }}</td>
                  </tr>
                  <tr>
                    <th>التكلفة</th>
                    <td>{{ course.cost }}</td>
                  </tr>
                  <tr>
                    <th>عدد الساعات</th>
                    <td>{{ course.total_hours }}</td>
                  </tr>
                  <tr>
                    <th>تاريخ انتهاء الدورة</th>
                    <td>{{ course.end_date }}</td>
                  </tr>
                    <tr>
                    <th>  أيام الدورة المتاحة</th>
                    <td>{{ course.number_of_days }}</td>
                  </tr>
                  <tr>
                    <th>المدرب</th>
                    <td>{{ course.instructor.full_name_ar }}</td>
                  </tr>
                  <tr>
                    <th>الصورة </th>
                    <td><img :src="course.image_full_path" height="200px"></td>
                  </tr>
                  <tr>
                    <th>محاور الدورة</th>
                    <td><p v-html="course.description"></p></td>
                  </tr>
                  <tr>
                    <th>محاور الدورة بالعربي</th>
                    <td><p v-html="course.description_ar"></p></td>
                  </tr>
                </table>
            </div>
             <div class="col-md-6">
                <!-- <h5>الطلاب المسجلين في الدورة</h5>
            <table class="table table-bordered">
              <tr>
                <th>#</th>
                <th>الإسم</th>
                <th>تاريخ التسجيل</th>
                <th>الحالة</th>
              </tr>
              <tr v-for="student in studentdata" v-bind:key="student.id">
                <td>{{student.student.id}}</td>
                  <td>{{student.student.first_name + ' ' + student.student.last_name}}</td>
                    <td>{{student.created_at}}</td>
                      <td>{{student.verified === 1?'غير نشط':'نشط'}}</td>
                </tr>
                </table> -->
             <div class="col-md-12">
                     <h5> العدد الإجمالي</h5>
            <table class="table table-bordered">
             <tr>
                    <th> عدد الطلاب الإجمالي في الدورة</th>
                    <td><p >{{student_payment.registered}}</p></td>
                  </tr>
                  <tr>
                     <th> عدد من قام بالدفع </th>
                    <td><p >{{student_payment.paid}}</p></td>
                  </tr>
                   <tr>
                     <th> عدد من لم يقوم بالدفع </th>
                    <td><p >{{student_payment.notPaid}}</p></td>
                  </tr>
                   <tr>
                     <th> إجمالي المبلغ المتوقع</th>
                    <td><p >{{student_payment.expectedAmount}}</p></td>
                  </tr>
                   <tr>
                     <th> إجمالي المبلغ المدفوع</th>
                    <td><p >{{student_payment.totalPaid}}</p></td>
                  </tr>
                  <tr>
                     <th> إجمالي المبلغ المتبقي</th>
                    <td><p >{{student_payment.residual}}</p></td>
                  </tr>
            </table>
                  </div>
                    <div class="col-md-12">
                    <h5>الطلاب المسجلين في الدورة</h5>
                <vdtnet-table
            ref="table"
            :fields="fields"
            :opts="options"
            @reloaded="doAfterReload"
            @table-creating="doCreating"
            @table-created="doCreated"
          >
          </vdtnet-table>
                  </div>
                  </div>
        </div>
        <div class="row">
          <h4>الوحدات</h4>
          <div class="col-md-8">
            <table class="table table-bordered">
              <tr>
                <th>#</th>
                <th>إسم الوحدة بالعربي</th>
                <th>إسم الوحدة بالإنجليزية</th>
              </tr>
              <tr v-for="(section, index) in sections"
                :key="index">
                <td>{{section.id}}</td>
                <td>{{section.name_ar}}</td>
                <td>{{section.name}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row">
          <h4>الدروس</h4>
          <div class="col-md-8">
            <table class="table table-bordered">
              <tr>
                <th>رقم الوحدة </th>
                <th>عنوان الدرس بالعربي</th>
                <th>عنوان الدرس بالإنجليزية</th>
                <th>حالة العرض</th>
                <th>الفديو</th>
              </tr>
              <tr v-for="(lesson, index) in lessons"
                :key="index">
                <td>{{lesson.section_id}}</td>
                <td>{{lesson.title_ar}}</td>
                <td>{{lesson.title}}</td>
                <td>{{lesson.free}}</td>
                <td><a v-bind:href="lesson.video_full_path" id="video-container" target="_blank">رابط للفديو</a></td>
              </tr>
            </table>
          </div>
        </div>
        <CButton color="warning" @click="goBack">رجوع</CButton>
      </CCardBody>
    </CCard>
  </CCol>
</CRow>
</template>

<script>
import $ from 'jquery'
import VdtnetTable from '../VdtnetTable.vue'
export default {
  name: 'ShowCourse',
  components: { VdtnetTable },
  data () {
    return {
      course: [],
      sections: [],
      lessons: [],
      student_payment: [],
      studentdata: {},
      totalpaied: [],
      notpaied: [],
      paied: [],
      studentsList: [],
      options: {
        ajax: {
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              'Authorization',
              'Bearer ' + localStorage.token
            )
          },
          url: this.$hostUrl + 'filter-students/' + this.$route.params.id,
          dataSrc: (json) => {
            return json.data
          }
        },
        dom:
          "<'row'<'col-sm-6 col-md-6'f><'col-sm-6 col-md-6 added'l>>" +
          "<'row'<'col-sm-12'Btr>>" +
          "<'row'<'col-sm-12 col-md-5'p><'col-sm-12 col-md-7'i>>",
        paging: true,
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/Arabic.json'
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: false,
        fixedHeader: true,
        saveState: true,
        select: {
          style: 'multi'
        }
      },
      fields: {
        students: {
          label: ' الطلاب',
          sortable: true,
          searchable: false,
          defaultOrder: 'desc'
        },
        status: {
          label: ' الحالة',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        created_at: {
          label: 'تاريخ الدفع',
          sortable: true,
          searchable: true,
          defaultOrder: 'desc'
        },
        quickSearch: '',
        details: {}
      }
    }
  },
  created () {
    const current = this
    this.$http
      .get(`${this.$hostUrl}courses/${this.$route.params.id}/edit`)
      .then((response) => {
        this.course = response.data.data.course
        console.log(this.course.id)
        $.each(this.course.sections, function (key, value) {
          current.sections.push({
            id: value.id,
            name: value.name,
            name_ar: value.name_ar
          })
          $.each(value.lessons, function (key, lesson) {
            current.lessons.push({
              id: lesson.id,
              title: lesson.title,
              title_ar: lesson.title_ar,
              free: (lesson.free ? 'مجاني' : 'مدفوع'),
              video_full_path: lesson.video_full_path,
              video: null,
              section_id: value.id,
              section_name: value.name_ar
            })
          })
        })
      })
    this.$http.get(`${this.$hostUrl}courses/${this.$route.params.id}`)
      .then((response) => {
        this.student_payment = response.data.data.input
        this.studentdata = response.data.data.student
        console.log(this.studentdata)
      })
    this.$http.get(`${this.$hostUrl}filter-students/${this.$route.params.id}`)
      .then((response) => {
        this.totalpaied = response.data.data
      })
  },
  methods: {
    doLoadTable (cb) {
      this.$http.getJSON(
        this.$hostUrl + 'filter-students/' + this.$route.params.id,
        function (data) {
          cb(data.data)
        }
      )
    },
    goBack () {
      this.$router.push({ path: '/courses' })
    },
    doAfterReload (data, table) {
      console.log('data reloaded')
    },
    doCreating (comp, el) {
      console.log('creating')
    },
    doCreated (comp) {
      console.log('created')
    },
    doSearch () {
      this.$refs.table.search(this.quickSearch)
    },
    doExport (type) {
      const parms = this.$refs.table.getServerParams()
      parms.export = type
    },
    formatCode (zipcode) {
      return zipcode.split('-')[0]
    }
  }
}
</script>
<style scoped>
  th {
    background-color: #3c4b64;
    color: #f5f3f3;
  }
  .main-table{
    display: inline-block;
    overflow: hidden;
  }
  .main-table p{
    width: 90%;
  }
  h5{
    font-weight: 700;
    background: #8adb76;
    color: #564e4e;
    padding: 10px 0;
    text-align: center;
    border-radius: 20px;
    font-size: 15px;
  }
 .dataTables_info{
   font-size: 14px !important;
 }
</style>
